<button class="none-button" (click)="onSelectSection(section)">
  <div #target [ngClass]="['section', isActive ? 'active' : '']">
    <h5 uni-heading weight="normal" [color]="isUnitPortalStyle ? 'primary-unit' : 'primary'">
      {{ section.name }}
    </h5>
  </div>
</button>
